import {
  MetricData, MetricDef,
} from 'store/graphs/types';

function compareDataNodeMetric(dataItem: MetricData, presetMetric: MetricDef) {
  return dataItem.node.join('_') === presetMetric.node.join('_');
}

export default compareDataNodeMetric;
